import React, { useMemo } from 'react';
import { TEAR_SHEET } from '../../constant';
import { computeBoxCbmFromDims } from './tearSheetUtils';

export default function TearSheetContainerLoadability({ masterPacks, loadabilityUnits = [] }) {
  const totalCbm = useMemo(() => {
    return masterPacks.reduce((sum, row) => {
      const v = computeBoxCbmFromDims(row.length, row.breadth, row.height);
      return sum + (v ?? 0);
    }, 0);
  }, [masterPacks]);

  const totalCft = totalCbm * 35.3147;

  const capacityRows = useMemo(() => {
    const list = Array.isArray(loadabilityUnits) ? loadabilityUnits : [];
    return list
      .filter((u) => u && u.is_default === false && u.active !== false)
      .map((u) => {
        const raw = u.relation_with_default ?? u.relationWithDefault ?? '';
        const cap = parseFloat(String(raw).replace(',', '.'));
        const name = (u.name || '').trim() || u.symbol || '—';
        return {
          key: String(u.id ?? name),
          name,
          capacityCbm: cap,
        };
      })
      .filter((r) => Number.isFinite(r.capacityCbm) && r.capacityCbm > 0)
      .sort((a, b) => a.capacityCbm - b.capacityCbm || a.name.localeCompare(b.name));
  }, [loadabilityUnits]);

  return (
    <section className="tear-sheet-section mt-2 tear-sheet-section-compact">
      <h6 className="tear-sheet-section-title">{TEAR_SHEET.SECTION_CONTAINER}</h6>
      <div className="d-flex gap-2 flex-wrap align-items-start">
        <div className="tear-sheet-load-summary row g-3 mb-2 col-12 col-lg-3">
          <div className="col-auto">
            <span className="tear-sheet-lbl d-block mb-0 me-5">Total CBM</span>
            <span className="tear-sheet-stat-val" title="Sum of master pack Box CBM">
              {totalCbm.toFixed(4)}
            </span>
          </div>
          <div className="col-auto">
            <span className="tear-sheet-lbl d-block mb-0">Total CFT</span>
            <span className="tear-sheet-stat-val" title="Total CBM × 35.3147">
              {totalCft.toFixed(4)}
            </span>
          </div>
        </div>
        <div className="table-responsive tear-sheet-load-table-wrap col-12 col-lg">
          <table className="table table-sm table-bordered mb-0 tear-sheet-load-table">
            <thead className="table-light">
              <tr>
                <th scope="col">Loadability</th>
                <th scope="col" className="text-end">
                  Cartons
                </th>
                <th scope="col" className="text-end">
                  Total PCS
                </th>
              </tr>
            </thead>
            <tbody>
              {capacityRows.length === 0 ? (
                <tr>
                  <td colSpan={3} className="text-muted small">
                    {TEAR_SHEET.LOADABILITY_EMPTY_HINT}
                  </td>
                </tr>
              ) : (
                capacityRows.map((row) => {
                  const cap = row.capacityCbm;
                  const ratio = cap / totalCbm;
                  const cartons =
                    totalCbm > 0 ? Math.ceil(Number(ratio.toFixed(4))) : null;
                  const pcs =
                    totalCbm > 0 ? Math.ceil(Number(ratio.toFixed(4)) * 3) : null;
                  return (
                    <tr key={row.key}>
                      <td title={`${cap} CBM`}>{row.name}</td>
                      <td className="text-end tear-sheet-load-ratio">
                        {cartons !== null ? cartons : '—'}
                      </td>
                      <td className="text-end tear-sheet-load-ratio">{pcs !== null ? pcs : '—'}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
